import { StandardDivider as StandardDividerTypes } from '@/schemas/sceneDataSchema';
import { Divider } from '@mui/material';

interface StandardDividerProps {
  component: StandardDividerTypes;
}

export const StandardDivider: React.FC<StandardDividerProps> = () => <Divider />;
